import PropTypes from 'prop-types';

export const addressPropType = PropTypes.shape({
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  district: PropTypes.string,
  region: PropTypes.string,
  postalCode: PropTypes.string,
  email: PropTypes.string,
  latitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  longitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  verification: PropTypes.shape({
    status: PropTypes.oneOf(['verified', 'autocomplete', 'unverified']),
    source: PropTypes.string,
    verifiedAt: PropTypes.string,
    manuallyEdited: PropTypes.bool,
    editedFields: PropTypes.arrayOf(PropTypes.string)
  })
});

export const formDefinitionPropType = PropTypes.shape({
  addressElements: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string,
    width: PropTypes.oneOf(['full', 'half', 'third']),
    editable: PropTypes.bool,
    maxLength: PropTypes.number,
    required: PropTypes.bool
  })),
  lookupField: PropTypes.string,
  requiredFields: PropTypes.arrayOf(PropTypes.string),
  postalCodeRegex: PropTypes.instanceOf(RegExp),
  verifyAfterAutocomplete: PropTypes.bool,
  wrapAddress1ToAddress2: PropTypes.bool
});

export const labelStringsPropType = PropTypes.shape({
  address1Label: PropTypes.string,
  address2Label: PropTypes.string,
  cityLabel: PropTypes.string,
  districtLabel: PropTypes.string,
  regionLabel: PropTypes.string,
  postalCodeLabel: PropTypes.string,
  invalidEmail: PropTypes.string,
  invalidPostalCode: PropTypes.string,
  fieldRequired: PropTypes.string,
  illegalCharacters: PropTypes.string,
  rateLimited: PropTypes.string,
  lookupError: PropTypes.string,
  validationError: PropTypes.string,
  loadingAddressForm: PropTypes.string,
  switchToAutocomplete: PropTypes.string,
  switchToManualEntry: PropTypes.string,
  switchToManuelEntry: PropTypes.string,
  addressLocation: PropTypes.string,
  openInMaps: PropTypes.string,
  usVerified: PropTypes.string,
  usVerifiedMessage: PropTypes.string,
  usMissingSecondaryTitle: PropTypes.string,
  usMissingSecondaryMessage: PropTypes.string,
  usInvalidSecondaryRequiredTitle: PropTypes.string,
  usInvalidSecondaryRequiredMessage: PropTypes.string,
  usInvalidSecondaryOptionalTitle: PropTypes.string,
  usInvalidSecondaryOptionalMessage: PropTypes.string,
  usVacantTitle: PropTypes.string,
  usVacantMessage: PropTypes.string,
  usNoStatTitle: PropTypes.string,
  usNoStatMessage: PropTypes.string,
  usNotConfirmedTitle: PropTypes.string,
  usNotConfirmedMessage: PropTypes.string,
  usNoResults: PropTypes.string,
  intlVerifiedTitle: PropTypes.string,
  intlVerifiedMessage: PropTypes.string,
  intlVerifiedSubBuildingChangedTitle: PropTypes.string,
  intlVerifiedSubBuildingChangedMessage: PropTypes.string,
  intlPartialTitle: PropTypes.string,
  intlPartialMessage: PropTypes.string,
  intlAmbiguousTitle: PropTypes.string,
  intlAmbiguousMessage: PropTypes.string,
  intlNotVerifiedTitle: PropTypes.string,
  intlNotVerifiedMessage: PropTypes.string,
  intlNoResults: PropTypes.string,
  smartyUsValidationStrings: PropTypes.shape({
    usInvalidSecondaryOptionalMessage: PropTypes.string,
    usInvalidSecondaryOptionalTitle: PropTypes.string,
    usInvalidSecondaryRequiredMessage: PropTypes.string,
    usInvalidSecondaryRequiredTitle: PropTypes.string,
    usMissingSecondaryMessage: PropTypes.string,
    usMissingSecondaryTitle: PropTypes.string,
    usNoResults: PropTypes.string,
    usNoStatMessage: PropTypes.string,
    usNoStatTitle: PropTypes.string,
    usNotConfirmedMessage: PropTypes.string,
    usNotConfirmedTitle: PropTypes.string,
    usVacantMessage: PropTypes.string,
    usVacantTitle: PropTypes.string,
    usVerified: PropTypes.string,
    usVerifiedMessage: PropTypes.string
  }),
  smartyIntlValidationStrings: PropTypes.shape({
    intlVerifiedTitle: PropTypes.string,
    intlVerifiedMessage: PropTypes.string,
    intlVerifiedSubBuildingChangedTitle: PropTypes.string,
    intlVerifiedSubBuildingChangedMessage: PropTypes.string,
    intlPartialTitle: PropTypes.string,
    intlPartialMessage: PropTypes.string,
    intlAmbiguousTitle: PropTypes.string,
    intlAmbiguousMessage: PropTypes.string,
    intlNotVerifiedTitle: PropTypes.string,
    intlNotVerifiedMessage: PropTypes.string,
    intlNoResults: PropTypes.string
  })
});
